export interface V1ErrorObject {
  detail?: string
  status?: number
  source?: {
    pointer?: string
    header?: string
    parameter?: string
    [key: string]: unknown
  }
  [key: string]: unknown
}

export class ApiError extends Error {
  public readonly error: V1ErrorObject
  constructor(error: V1ErrorObject) {
    super(error.detail || 'Unknown error')
    this.error = error
  }
}
